import { Component, Injector, OnInit } from '@angular/core';
import { TableColumn } from '@models/tableColumn';
import { PricingsService } from '@services/entity/pricings.service';
import { StripeInfosService } from '@services/entity/stripe-infos.service';
import { plainToClass } from 'class-transformer';
import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { TableOptions } from '@models/tableOptions';
import { UsersService } from '@services/entity/users.service';
import { InvoiceDto } from '@dto/invoiceDto';
import { UserDto } from '@dto/userDto';
import { PaymentReceiptDto } from '@dto/paymentReceiptDto';
import { KwhPipe } from 'src/app/pipes/kwh.pipe';
import { DEDatePipe } from 'src/app/pipes/de-date.pipe';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { PaymentsService } from '@services/payments/payments.service';
import { BillingMethodEnum } from '@enums/billingMethodEnum.enum';

@Component({
  selector: 'app-payment-receipts-table',
  templateUrl: './payment-receipts-table.component.html',
  styleUrls: ['./payment-receipts-table.component.scss'],
})
export class PaymentReceiptsTableComponent extends AbstractEntitiesTableComponent implements OnInit {

  public className = 'PaymentReceiptsTableComponent'

  public entities: PaymentReceiptDto[] = []
  public hasStripeAccount: boolean
  public ownerUserId: string
  public ownerCustomerId: number
  public userId: string

  public isUser: boolean = false
  public isCustomer: boolean = false
  public isOperator: boolean = false

  public user: UserDto
  public users: UserDto[] = []
  public usersWithPricing: UserDto[] = []

  public tableColumns: TableColumn[] = [
    { columnDescription: `Bezahlt am`, property: 'receiptCreatedDate', options:
      { tdStyleClasses: 'receiptCreatedDate', columnPipe: { pipe: new DEDatePipe() }, datePipeFormat: 'yyyy.MM.dd' }
    },
    { columnDescription: `Beleg`, property: 'receiptURL', options:
      { tdStyleClasses: 'receipt', isLink: true }
    },
  ];

  public tableOptions: TableOptions = {
    hideActions: true,
    hideSearchAll: true
  };

  constructor(
    public pricingsService: PricingsService,
    public stripeInfosService: StripeInfosService,
    public paymentsService: PaymentsService,
    public usersService: UsersService,
    injector: Injector
  ) {
    super(pricingsService, injector)
  }

  ngOnInit(): void {
    this.getRoles()

    if (this.isCustomer || this.isOperator) {
      this.ownerCustomerId = localStorage.getItem('customerId') ? parseInt(localStorage.getItem('customerId')) : undefined

      this.tableColumns.unshift(
        { columnDescription: `Tariftyp`, property: 'receiptTypeText', options:
          { tdStyleClasses: 'receiptTypeText' }
        },
        { columnDescription: `Betrag`, property: 'amountCaptured', options:
          { tdStyleClasses: 'amountCaptured', columnPipe: { pipe: new CurrencyPipe('de-DE', 'EUR') }, factor: .01 }
        },
        { columnDescription: `Benutzer`, property: 'userFullName', options:
          { tdStyleClasses: 'payerFullName' }
        },
        { columnDescription: `Gebühr`, property: 'applicationFee', options:
          { tdStyleClasses: 'applicationFee', columnPipe: { pipe: new CurrencyPipe('de-DE', 'EUR') }, factor: .01 }
        },
      )

    } else if (this.isUser) {
      this.userId = localStorage.getItem('userId')

      this.tableColumns.unshift(
        { columnDescription: `Tariftyp`, property: 'receiptTypeText', options:
          { tdStyleClasses: 'receiptTypeText' }
        },
        { columnDescription: `Betrag`, property: 'amountCaptured', options:
          { tdStyleClasses: 'amountCaptured', columnPipe: { pipe: new CurrencyPipe('de-DE', 'EUR') }, factor: .01 }
        },
        { columnDescription: `Empfänger`, property: 'customerFullName', options:
          { tdStyleClasses: 'recipientFullName' }
        }
      )
    }

    this.getUser()
  }

  getUser() {
    this.usersService.getLoggedInUser().subscribe(user => {
      this.user = plainToClass(UserDto, user)
      super.ngOnInit()
    })
  }

  async initializeEntities() {
    if (this.isOperator) {
      const selectedCustomerId = this.activatedRoute.parent.snapshot.params.key
      this.paymentsService.getPaymentReceiptsOfSelectedCustomer(selectedCustomerId).subscribe(paymentReceipts => {
          this.entities = plainToClass(PaymentReceiptDto, paymentReceipts)
          this.sortReceipts()
          super.setupTable()
          this.mapReceiptType()
          this.tableReady = true
      })
    } else if (this.isCustomer) {
      this.paymentsService.getPaymentReceiptsOfCustomer(this.user.id).subscribe(paymentReceipts => {
        this.entities = plainToClass(PaymentReceiptDto, paymentReceipts)
        this.sortReceipts()
        super.setupTable()
        this.mapReceiptType()
        this.tableReady = true
      })
    } else if (this.isUser) {
      this.paymentsService.getPaymentReceiptsOfUser(this.user.id).subscribe(paymentReceipts => {
        this.entities = plainToClass(PaymentReceiptDto, paymentReceipts)
        this.sortReceipts()
        super.setupTable()
        this.mapReceiptType()
        this.tableReady = true
      })
    }
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Operator')) this.isOperator = true;
    if (this.authenticationService.userHasRole('Customer')) this.isCustomer = true;
    if (this.authenticationService.userHasRole('User')) this.isUser = true;
  }

  matches(entity: any, term: any) {
    throw new Error('Method not implemented.');
  }

  mapReceiptType() {
    this.entities.forEach(entity => {
      if (entity.billingMethod == BillingMethodEnum.Manual) entity.receiptTypeText = 'Manuell'
      if (entity.billingMethod == BillingMethodEnum.QRCode) entity.receiptTypeText = 'QR-Code'
      if (entity.billingMethod == BillingMethodEnum.Automatic) entity.receiptTypeText = 'Automatisch'
    });
  }

  sortReceipts() {
    this.entities.sort((a, b) => {
      var dateA = new Date(a.receiptCreatedDate);
      var dateB = new Date(b.receiptCreatedDate);
      return dateB.getTime() - dateA.getTime();
    })
  }
}
